import {
  register,
  CloudObject,
  InstanceOrTag,
  Transaction,
  defineProperty,
  Property,
  BrickContext,
  Query,
  Predicate,
} from 'olympe';
import { Observable } from 'rxjs';

export class Configs extends CloudObject {
  static keyProp: Property<string>;
  static valueProp: Property<string>;

  static create(transaction: Transaction) {
    return transaction.create(Configs);
  }

  getKey() {
    return this.get(Configs.keyProp);
  }

  observeKey($: BrickContext) {
    return this.observe($, Configs.keyProp);
  }

  getValue() {
    return this.get(Configs.valueProp);
  }

  observeValue($: BrickContext): Observable<string> {
    return this.observe($, Configs.valueProp);
  }

  static setKey(transaction: Transaction, instance: InstanceOrTag, value: string) {
    transaction.update(instance, Configs.keyProp, value);
  }

  static setValue(transaction: Transaction, instance: InstanceOrTag, value: string) {
    transaction.update(instance, Configs.valueProp, value);
  }

  static observe(key: string, $: BrickContext): Observable<any> {
    const query = Query.instancesOf(Configs).filter(
      Predicate.contains(Configs.keyProp, key, false)
    );
    return query.observe($);
  }

  static async find(
    key: string,
    $: BrickContext
  ): Promise<Configs | undefined> {
    const query = Query.instancesOf(Configs).filter(
      Predicate.contains(Configs.keyProp, key, false)
    );
    return (await query.execute()).toArray()[0];
  }
}

// Hardcoded tags
register('01899b6eed55af1bef88', Configs);
Configs.keyProp = defineProperty('01899b6eed54c92d5107');
Configs.valueProp = defineProperty('01899b6eed555ab84d16');
